/* Revelacao no scroll. Ver o comentario do lz-motion.css para as regras. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELETORES = [
    /* home */
    '.cc-testimonials__card', '.routine-testimonials__card', '.daily-ritual__slide',
    '.faq-accordion__column', '.benefits-accordion__item', '.lymphoria-benefits__item',
    /* landing (nomes conferidos no DOM da pagina no ar) */
    '.review_slider_custom_slider_new_item',
    '.review_with_text_landing_page_item',
    '.section3_icons_lp .icons_with_text_item',
    '.money_section_lp .custom-flex_item_ad_2',
    /* titulos de secao das duas */
    '.rich-text_custom__heading', '.cc-testimonials__heading', '.lz-subheadline'
  ].join(',');

  function iniciar() {
    var alvos = Array.prototype.slice.call(document.querySelectorAll(SELETORES));
    if (!alvos.length) return;

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('lz-in');
        observador.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    var limiteDobra = window.innerHeight * 1.1;
    var porPai = new Map();

    alvos.forEach(function (el) {
      /* acima da dobra fica quieto: animar o topo atrasa o LCP */
      if (el.getBoundingClientRect().top < limiteDobra) return;

      /* cascata leve entre irmaos do mesmo pai */
      var pai = el.parentElement;
      var n = (porPai.get(pai) || 0);
      porPai.set(pai, n + 1);
      if (n > 0 && n < 4) el.setAttribute('data-lz-delay', String(n));

      el.classList.add('lz-reveal');
      observador.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
